// src/pages/Blog.jsx
import React from "react";
import CustomNavbar from "../components/CustomNavbar";
import BlogBanner from "../components/BlogBanner";   // banner for blog page


import Footer from "../components/Footer";
import BlogPage from "../components/BlogPage";

const Blog = () => {
  return (
    <>
      <CustomNavbar />
      <BlogBanner />
     <BlogPage/>
      <Footer />
    </>
  );
};

export default Blog;
